import { browser } from '$app/environment';
import { ApplicationEvent } from '$shared/constants/ApplicationEvent';
import type {
  IAuthorizedListener,
  IMaintenanceListener,
  IUnauthorizedListener,
  IUserOrgChangeListener
} from '$shared/interfaces/IEventListener';

class Application {
  private element: Element;
  constructor() {
    if (browser) {
      this.element = document.createElement('div');
    }
  }

  addAuthorizationEventListener(listener: IAuthorizedListener): void {
    if (browser) {
      this.element.addEventListener(ApplicationEvent.OnAuthorized, () => {
        listener.onUserAuthorizedAsync();
      });
    }
  }

  addUnAuthorizationEventListener(listener: IUnauthorizedListener): void {
    if (browser) {
      this.element.addEventListener(ApplicationEvent.OnUnauthorized, () => {
        listener.onUserUnauthorized();
      });
    }
  }

  addMaintenanceEventListener(listener: IMaintenanceListener): void {
    if (browser) {
      this.element.addEventListener(ApplicationEvent.OnMaintenance, () => {
        listener.onMaintenance();
      });
    }
  }

  addUserOrgChangeEventListener(listener: IUserOrgChangeListener): void {
    if (browser) {
      this.element.addEventListener(ApplicationEvent.OnUserOrgChanged, () => {
        listener.onUserOrgChanged();
      });
    }
  }

  dispatchEvent(eventName: ApplicationEvent): void {
    if (browser) {
      this.element.dispatchEvent(new CustomEvent(eventName));
    }
  }
}

export default new Application();
